import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { ExportDataProvider } from "../../data-provider/export.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { PermissionCheck } from "../../shared/permission";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { Organisation } from "../../models/organisation.model";

let OrganisationResultExportComponent = {
    selector: "vcOrganisationResultExport",
    templateUrl:
        "/angular/components/organisation/result-export.component.html",
    bindings: {
        survey: "=?",
    },
    controller: class OrganisationResultExportController {
        // * bindings for typescript compiler *
        public survey?: any;
        // ************************************

        public activeOrganisation: Organisation;
        private readonly isLeaderView: boolean;
        private canvass_types: any = [];
        private errorMessage: boolean = false;
        private errors = { app: "" };
        private params: any = { categories: [], surveys: [] };
        private surveys = [];
        private activeCampaign: Campaign;

        private $location: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        private exportDataProvider: ExportDataProvider;
        public permissionProvider: PermissionCheck;
        private divisionDataProvider: DivisionDataProvider;
        private surveyDataProvider: SurveyDataProvider;

        constructor(
            ExportDataProvider: ExportDataProvider,
            __app_type: any,
            $location: any,
            PermissionCheck: PermissionCheck,
            DivisionDataProvider: DivisionDataProvider,
            SurveyDataProvider: SurveyDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$location = $location;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.divisionDataProvider = DivisionDataProvider;
            this.surveyDataProvider = SurveyDataProvider;
            this.exportDataProvider = ExportDataProvider;
            this.permissionProvider = PermissionCheck;

            this.isLeaderView = __app_type == "LEADER";
            this.activeCampaign = CampaignDataProvider.activeCampaign;
            this.activeCampaign.getCampaignCanvassingType().then((data) => {
                this.canvass_types = _.cloneDeep(data);
                this.canvass_types.forEach((value, index) => {
                    value.checked = true;
                    this.params.categories.push(value.ctname);
                });
            });
            CampaignDataProvider.getOrganisations().then(
                (organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                    this.activeOrganisation.checked = true;
                }
            );
        }

        $onInit() {
            this.divisionDataProvider.getAllDivisions().then((divisions) => {
                this.setAllCheckboxes(divisions, true);
                this.activeOrganisation.divisions = divisions;
            });

            if (!this.survey) {
                this.surveyDataProvider.getAllSurveys().then((surveys) => {
                    this.surveys = surveys;
                });
            } else {
                this.params.surveys.push(this.survey);
                this.params.surveyOnly = true;
            }
        }

        checkCanvassType(ctname: string): boolean {
            const index = this.params.categories.indexOf(ctname);
            return index > -1;
        }

        changeCanvassType(ctname: string): void {
            this.errorMessage = false;
            this.errors.app = "";
            const indexCanvass = this.params.categories.indexOf(ctname);
            if (indexCanvass > -1) {
                this.params.categories.splice(indexCanvass, 1);
            } else {
                this.params.categories.push(ctname);
            }
        }

        getCheckedSurveys(): string[] {
            let checkedSurveys = [];
            for (const survey of this.surveys) {
                if (angular.isDefined(survey.checked) && survey.checked) {
                    checkedSurveys.push(survey.sid);
                }
            }
            return checkedSurveys;
        }

        exportData(): void {
            if (
                this.canvass_types.length > 1 &&
                !this.params.categories.length
            ) {
                this.errorMessage = true;
                this.errors.app = "Please select at least one app";
            } else {
                this.dialog.cancel();
                this.errorMessage = false;
                this.params.surveys = this.params.surveyOnly
                    ? this.params.surveys
                    : this.getCheckedSurveys();
                this.params.timezone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                this.params.start = {
                    day: new Date(this.params.start_date).getDate(),
                    month: new Date(this.params.start_date).getMonth() + 1,
                    year: new Date(this.params.start_date).getFullYear(),
                };
                this.params.end = {
                    day: new Date(this.params.end_date).getDate(),
                    month: new Date(this.params.end_date).getMonth() + 1,
                    year: new Date(this.params.end_date).getFullYear(),
                };
                this.params.campaigns = [];
                if (this.params.surveys.length > 0) {
                    this.params.effortsIDs = [];
                }

                for (
                    let i = 0;
                    i < this.activeOrganisation.divisions.length;
                    i++
                ) {
                    let division = this.activeOrganisation.divisions[i];
                    for (let j = 0; j < division.campaigns.length; j++) {
                        if (division.campaigns[j].checked === true) {
                            this.params.campaigns.push(
                                division.campaigns[j].campaignid
                            );
                        }
                    }
                }

                this.exportDataProvider.canvasses({ params: this.params }).then(
                    () => {
                        this.toast
                            .action("Export Started", "Show")
                            .then((value: string) => {
                                if (value == "ok") {
                                    if (this.isLeaderView) {
                                        this.$location.url("/leader_exports");
                                    } else {
                                        this.$location.url("/exports");
                                    }
                                }
                            });
                    },
                    () => this.toast.error()
                );
            }
        }

        setAllCheckboxes(divisions: Division[], checked: boolean): void {
            for (let i = 0; i < divisions.length; i++) {
                divisions[i].checked = checked;
                let campaigns = divisions[i].campaigns;
                for (let j = 0; j < campaigns.length; j++) {
                    campaigns[j].checked = checked;
                }
            }
        }

        checkDivisionCheckboxes(): boolean {
            let allSelected = true;
            let divisions = this.activeOrganisation.divisions;
            for (let i = 0; i < divisions.length; i++) {
                if (!divisions[i].checked) {
                    allSelected = false;
                    break;
                }
            }
            return allSelected;
        }

        selectAll(): void {
            let divisions = this.activeOrganisation.divisions;
            let checked = this.activeOrganisation.checked;
            this.setAllCheckboxes(divisions, checked);
        }

        selectAllCampaignsInDivision(division): void {
            let campaigns = division.campaigns;
            for (let j = 0; j < campaigns.length; j++) {
                campaigns[j].checked = division.checked;
            }
            this.activeOrganisation.checked =
                division.checked && this.checkDivisionCheckboxes();
        }

        selectCampaign(campaign: Campaign, division): void {
            if (campaign.checked) {
                let allSelected = true;
                for (let i = 0; i < division.campaigns.length; i++) {
                    if (!division.campaigns[i].checked) {
                        allSelected = false;
                        break;
                    }
                }
                division.checked = allSelected;
                if (allSelected) {
                    this.activeOrganisation.checked =
                        this.checkDivisionCheckboxes();
                }
            } else {
                this.activeOrganisation.checked = division.checked = false;
            }
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("organisation")
    .component(
        OrganisationResultExportComponent.selector,
        OrganisationResultExportComponent
    );
